import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=e7f63e20&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=e7f63e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f63e20",
  null
  
)

export default component.exports